export const MAX_DISPLAYED_FILTER_VALUES = 3;
